export const defaultClipartTableValue = () => {
  return {
    title: "",
    styles: { bg_color: "white", font_color: "black"},
    properties: [],
  };
};

export const defaultClipartTablePropertyValue = () => {
  return {
    styles: { bg_color: "white", font_color: "black" },
    clipart: null,
    num_images: 0,
    is_user_selectable: false,
    answer: null,
  };
}
